import { render } from "./lookupresult_image.vue?vue&type=template&id=167b263a"
import script from "./lookupresult_image.vue?vue&type=script&lang=js"
export * from "./lookupresult_image.vue?vue&type=script&lang=js"

import "./lookupresult_image.vue?vue&type=style&index=0&id=167b263a&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__